var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.60103 4.68255L9.31648 5.39801L2.2708 12.4437H1.55534V11.7282L8.60103 4.68255ZM11.4006 0.000976562C11.2062 0.000976562 11.004 0.0787435 10.8563 0.226501L9.43314 1.64964L12.3494 4.5659L13.7725 3.14276C14.0758 2.83947 14.0758 2.34954 13.7725 2.04625L11.9528 0.226501C11.7973 0.0709668 11.6028 0.000976562 11.4006 0.000976562ZM8.60103 2.48174L0 11.0828V13.999H2.91626L11.5173 5.39801L8.60103 2.48174Z",
    fill: "#037A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPrimary);
export default __webpack_public_path__ + "static/media/Edit_primary.680208ff4e7c1603f1acd308be31546b.svg";
export { ForwardRef as ReactComponent };